module.exports = __webpack_public_path__ + "img/algolia.224640ca.png";